import type { TRuleWithTheme } from 'styles/theme';

import { AssistantMode } from '../../types';

export const container: TRuleWithTheme<{ mode: AssistantMode }> = ({ theme, mode }) => ({
    borderRadius: '0.75rem',
    border: `1px solid ${mode === AssistantMode.SQL ? theme.colors.info : theme.colors.borderColor}`,
    backgroundColor: mode === AssistantMode.SQL ? theme.colors.bgStatusInfo : theme.colors.bgPrimary,
    overflow: 'hidden',
});

export const toggle: TRuleWithTheme = () => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: '0.875rem 1.125rem',
    cursor: 'pointer',
    background: 'none',
    border: 'none',
});

export const toggleLabel: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    color: theme.colors.text,
    fontWeight: 600,
    fontSize: '0.875rem',
});

export const chevron: TRuleWithTheme<{ open: boolean }> = ({ theme, open }) => ({
    color: theme.colors.iconActive,
    transition: 'transform 0.15s ease',
    transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
});

export const body: TRuleWithTheme = ({ theme }) => ({
    padding: '0 1.125rem 1.125rem',
    backgroundColor: theme.colors.white,
});

export const grid: TRuleWithTheme = () => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
    gap: '0.75rem',
});

export const empty: TRuleWithTheme = ({ theme }) => ({
    color: theme.colors.textSecondary,
    fontSize: '0.875rem',
});
